import { FamilyAnswersResponseDto, FamilyAnswerStatsDto } from '@families-link/shared';
import { Container, Box, Typography, Divider } from '@mui/material';
import { useGetFamilyQuestionAnswersQuery, useGetSurveyTemplateByIdQuery } from '../../../../../store/api/survey.api';
import { FC, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { useSortingParams, usePaginatedData } from '../../../../_core/hooks';
import { FamilyQuestionAnswersTable } from '../../../components/family-questions-answer-table/family-questions-answers-table.component';

export type FamilyAnswersPageProps = {
	isAdminRoute: boolean;
	currentDistrictId?: string | null;
};
export const FamilyAnswersPage: FC<FamilyAnswersPageProps> = ({ isAdminRoute, currentDistrictId }) => {
	const [t] = useTranslation();
	const isFirstRender = useRef(true);

	const { phoneNumber, surveyTemplateId } = useParams();
	const { data: surveyTemplate } = useGetSurveyTemplateByIdQuery(surveyTemplateId!);

	const { sortingArray, sortingParams, handleSortingChange } = useSortingParams();

	const location = useLocation();
	const familyAnswer = location.state?.familyAnswer as FamilyAnswerStatsDto | undefined;

	const { requestObject, meta, handleResetPage, itemsList, fetchMore } = usePaginatedData<FamilyAnswersResponseDto>(
		useGetFamilyQuestionAnswersQuery,
		{
			surveyTemplateId,
			engagementId: familyAnswer?.engagementId,
			phoneNumber,
			...sortingParams,
			district: currentDistrictId,
		},
		{
			refetchOnMountOrArgChange: true,
		}
	);
	const { isFetching, isLoading } = requestObject;

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;

			return;
		}
		handleResetPage();
	}, [sortingArray, handleResetPage]);

	return (
		<Container
			maxWidth={false}
			sx={{ display: 'flex', flexDirection: 'column', height: '100%', paddingBottom: '16px', gap: 2 }}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}
			>
				<Box display="flex" alignItems="center" gap={2}>
					<Typography sx={{ fontSize: '20px', fontWeight: 400 }}>{requestObject?.data?.familyName}</Typography>
					<Divider orientation="vertical" flexItem />
					<Typography sx={{ fontSize: '12px', fontWeight: 400 }}>{requestObject?.data?.engagementTitle}</Typography>
				</Box>
			</Box>
			<FamilyQuestionAnswersTable
				data={itemsList ?? []}
				loading={isFetching || isLoading}
				hasMore={meta?.hasNextPage}
				fetchMore={fetchMore}
				sorting={sortingArray}
				onSortingChange={handleSortingChange}
			/>
		</Container>
	);
};
